import { render } from "./AppLogoOnly.vue?vue&type=template&id=dce8c9a4"
import script from "./AppLogoOnly.vue?vue&type=script&lang=ts"
export * from "./AppLogoOnly.vue?vue&type=script&lang=ts"
script.render = render

export default script